import {
  CallScribeNoteOutcome,
  ICallScribeNoteDestination,
} from 'services/callScribe/types';

export const BOTH_POSTED = 'The entry and both notes are on the ticket.';

export const CUSTOMER_ONLY =
  'The entry and the customer note are on the ticket. You chose not to post the internal note.';

export const INTERNAL_ONLY =
  'The entry and the internal note are on the ticket. You chose not to post the customer note.';

export const NEITHER =
  'The entry is on the ticket. You chose not to post either note.';

export const CUSTOMER_FAILED = 'The customer note could not be posted.';

export const SKIPPED_EMPTY_SUCCESS_LINE =
  'No customer note was posted: there was nothing to summarise.';

export const NOTE_OUTCOME_LABEL: Record<string, string> = {
  [CallScribeNoteOutcome.Posted]: 'Posted',
  [CallScribeNoteOutcome.Failed]: 'Could not be posted',
  [CallScribeNoteOutcome.SkippedByTechnician]: 'Skipped by the technician',
  [CallScribeNoteOutcome.TurnedOff]: 'Off in Ticketing settings',
  [CallScribeNoteOutcome.SkippedEmpty]: 'Skipped: nothing to summarise',
};

export const noteOutcomeLabel = (
  outcome: string | null | undefined,
): string => {
  const value = read(outcome);
  if (value === '' || value === CallScribeNoteOutcome.NotRecorded) {
    return '';
  }
  return NOTE_OUTCOME_LABEL[value] ?? '';
};

const read = (value: string | null | undefined): string =>
  typeof value === 'string' ? value : '';

const skipped = (value: string | null | undefined): boolean =>
  read(value) === CallScribeNoteOutcome.SkippedByTechnician;

const posted = (value: string | null | undefined): boolean =>
  read(value) === CallScribeNoteOutcome.Posted;

const failed = (value: string | null | undefined): boolean =>
  read(value) === CallScribeNoteOutcome.Failed;

export const successLine = (
  customerOutcome: string | null | undefined,
  internalOutcome: string | null | undefined,
): string => {
  if (read(customerOutcome) === '' && read(internalOutcome) === '') {
    return BOTH_POSTED;
  }
  if (read(customerOutcome) === CallScribeNoteOutcome.SkippedEmpty) {
    return SKIPPED_EMPTY_SUCCESS_LINE;
  }
  if (skipped(customerOutcome) && skipped(internalOutcome)) {
    return NEITHER;
  }
  if (skipped(internalOutcome)) {
    return CUSTOMER_ONLY;
  }
  if (skipped(customerOutcome)) {
    return INTERNAL_ONLY;
  }
  return BOTH_POSTED;
};

export const destinationLine = (
  customerOutcome: string | null | undefined,
  destination: string | null | undefined,
  known: ICallScribeNoteDestination[] | null | undefined,
): string => {
  if (!posted(customerOutcome) || read(destination) === '') {
    return '';
  }
  const match = (known ?? []).find(d => d.value === destination);
  return match ? `The customer note went to ${match.label}.` : '';
};

export const failureLine = (
  customerOutcome: string | null | undefined,
): string => (failed(customerOutcome) ? CUSTOMER_FAILED : '');
